import { render, staticRenderFns } from "./IframeTemplatemld.vue?vue&type=template&id=7f6c5024&scoped=true&"
import script from "./IframeTemplatemld.vue?vue&type=script&lang=js&"
export * from "./IframeTemplatemld.vue?vue&type=script&lang=js&"
import style0 from "./IframeTemplatemld.vue?vue&type=style&index=0&id=7f6c5024&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6c5024",
  null
  
)

export default component.exports